module.exports = __webpack_public_path__ + "spambackend.png?600114f612a63e70905090a1f08f6b96";